// extracted by mini-css-extract-plugin
export var footer = "_pp-0";
export var inherit = "_pp-1";
export var input = "_pp-2";
export var modalContent = "_pp-3";
export var quillEditor = "_pp-4";
export var subtitle = "_pp-5";